const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const NewDealsActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

NewDealsActions.fetchData.listen(function(period, comparison, users, funnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    comparison_start_date: dateToParam(comparison.startDate),
    comparison_end_date: dateToParam(comparison.endDate),
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/new_deals", params, this.completed, this.failed);
});

module.exports = NewDealsActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/new-deals-actions.js